module.exports = __webpack_public_path__ + "img/GY.7f21a739.png";